export const ADD_TO_CART = 'GIFTYA/ADD_TO_CART';
export const ADD_TO_CART_RESET = 'GIFTYA/ADD_TO_CART_RESET';

export const addToCart = (payload, meta = {}, error = false) => ({
    type: ADD_TO_CART,
    payload,
    meta,
    error
});
export const addToCartReset = (payload, meta, error) => ({
    type: ADD_TO_CART_RESET,
    payload,
    meta,
    error
});